import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Booking } from '../../domain/booking';
import useAlterBookingState from '../hooks/useAlterBookingState';

const buildOptimisticResponse = (
    booking: Booking,
    statusField: keyof Booking,
    value: boolean
) => ({
    alterBookingState: {
        __typename: 'Booking',
        id: booking.id,
        reference: booking.reference,
        importedToGovernmentPortal:
            statusField === 'importedToGovernmentPortal'
                ? value
                : booking.importedToGovernmentPortal,
        detailsRequested:
            statusField === 'detailsRequested'
                ? value
                : booking.detailsRequested,
        detailsRecorded:
            statusField === 'detailsRecorded'
                ? value
                : booking.detailsRecorded,
        hasInstructions:
            statusField === 'hasInstructions'
                ? value
                : booking.hasInstructions,
        accommodationReady:
            statusField === 'accommodationReady'
                ? value
                : booking.accommodationReady,
        accommodationVerified:
            statusField === 'accommodationVerified'
                ? value
                : booking.accommodationVerified,
        keysSecured:
            statusField === 'keysSecured' ? value : booking.keysSecured,
        hasReview:
            statusField === 'hasReview' ? value : booking.hasReview,
    },
});

const BookingChecklistItemState = ({
    booking,
    statusField,
    label,
}: {
    label?: string;
    booking: Booking;
    statusField: keyof Booking;
}) => {
    const [alterBookingState] = useAlterBookingState(booking.id);
    const checked = !!booking[statusField];

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    color="success"
                    onChange={() => {
                        const newValue = !checked;
                        alterBookingState({
                            variables: {
                                id: booking.id,
                                fields: { [statusField]: newValue },
                            },
                            optimisticResponse: buildOptimisticResponse(
                                booking,
                                statusField,
                                newValue
                            ),
                        });
                    }}
                />
            }
            label={label}
        />
    );
};

export default BookingChecklistItemState;
